// extracted by mini-css-extract-plugin
export default {"settings":"G_dARqUzMJ","field":"hopObWmI9G","label":"XdLAsTUIAX","dark":"HBjd9XSVBY"};